module.exports = __webpack_public_path__ + "img/search.a4c800cf.svg";